module.exports = __webpack_public_path__ + "img/content-ecosystem-mobile.29f048b9.png";